export const ANNOUNCEMENTS_LOCALSTORAGE = 'oskari-announcements';
export const BASE_LAYERS_LOCALSTORAGE = 'selected-base-layers';
export const DRAWING_TIP_LOCALSTORAGE = 'drawing-tip-localstorage';
export const SEARCH_TIP_LOCALSTORAGE = 'search-tip-localstorage';
export const GFI_GEOMETRY_LAYER_ID = 'drawtools-geometry-layer';
// This is the id of the vector layer of drawing feature selection (ongoing)
export const FEATURE_SELECTION_DRAWING_TOOL = 'feature-selection-drawing-tool';
// This is the id for the vector layer of selected or drawn feature selection
export const FEATURE_SELECTION_LAYER = 'feature-selection-layer';
export const BODY_SIZE_EXCEED = "BODY_SIZE_EXCEED";
export const GENERAL_FAIL = "GENERAL_FAIL";
export const VECTOR_LAYER_ID = 'SEARCH_VECTORLAYER';
export const MAX_RECONNECTIONS_FEATURE_DATA_DOWNLOAD = 20;
// VM root route
export const VM_ROOT_ROUTE = "/spa/"
// Sv root route
export const SV_ROOT_ROUTE = "/"

// Geojson ids
export const SEARCH_GEOJSON_ARRAY_ID = "search-geojson-array"
